import type { ProductionRequestStatus } from '../types/records'

export const PRODUCTION_REQUEST_DEFAULT_STATUS: ProductionRequestStatus = 'draft'
export const PRODUCTION_REQUEST_LINE_DEFAULT_STATUS = 'pending' as const
export const PRODUCTION_REQUEST_LINE_DEFAULT_PRIORITY = 3
export const PRODUCTION_REQUEST_LINE_DEFAULT_SHIPPED_QTY = 0

/** Поля шапки заявки при создании (status обязателен в PB). */
export function buildProductionRequestCreateBody(
  body: Record<string, unknown>,
): Record<string, unknown> {
  return {
    ...body,
    status: PRODUCTION_REQUEST_DEFAULT_STATUS,
    clientUrgent: Boolean(body.clientUrgent),
  }
}

/** Поля строки заявки при создании (status, priority, shippedQty). */
export function buildProductionRequestLineCreateBody(
  lineBody: Record<string, unknown>,
  priority = PRODUCTION_REQUEST_LINE_DEFAULT_PRIORITY,
): Record<string, unknown> {
  const p = Math.min(5, Math.max(1, Number(priority) || PRODUCTION_REQUEST_LINE_DEFAULT_PRIORITY))
  const { priority: _ignored, shippedQty: _shipped, ...rest } = lineBody
  const shipped = Number(_shipped)
  return {
    ...rest,
    status: PRODUCTION_REQUEST_LINE_DEFAULT_STATUS,
    priority: p,
    shippedQty: Number.isFinite(shipped) ? shipped : PRODUCTION_REQUEST_LINE_DEFAULT_SHIPPED_QTY,
  }
}

export type LineDraftForValidation = {
  productId: string
  quantity: string
  priority?: string
}

/** Проверка позиций до записи в БД (чтобы не создавать шапку заявки при ошибке в строках). */
export function validateProductionRequestLineDrafts(drafts: LineDraftForValidation[]): void {
  if (drafts.length === 0) {
    throw new Error('Добавьте хотя бы одну позицию заявки.')
  }
  for (const row of drafts) {
    const raw = Number(String(row.quantity).replace(',', '.'))
    const qty = Math.round(raw * 1e6) / 1e6
    if (!Number.isFinite(qty) || qty <= 0) {
      throw new Error('В каждой позиции укажите количество больше нуля.')
    }
    if (!row.productId) {
      throw new Error('В каждой позиции выберите номенклатуру (продукцию).')
    }
  }
}

export function linePriorityFromDraft(row: LineDraftForValidation): number {
  const linePriority = row.priority?.trim()
  if (!linePriority) return PRODUCTION_REQUEST_LINE_DEFAULT_PRIORITY
  return Math.min(5, Math.max(1, Number(linePriority) || PRODUCTION_REQUEST_LINE_DEFAULT_PRIORITY))
}
